import { render, staticRenderFns } from "./setup-wizard.vue?vue&type=template&id=5e5f0b44&scoped=true&"
import script from "./setup-wizard.vue?vue&type=script&lang=js&"
export * from "./setup-wizard.vue?vue&type=script&lang=js&"
import style0 from "./setup-wizard.vue?vue&type=style&index=0&id=5e5f0b44&lang=scss&scoped=true&"
import style1 from "./setup-wizard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5f0b44",
  null
  
)

export default component.exports